/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-19 18:40:48
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-07 00:17:46
 * @Description: file content
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import global_ from "./global.config";
import VueLazyload from 'vue-lazyload';

/**
 * 饿了么手机端ui，用到的具体组件，在具体的页面 import
 * 例如：import { MessageBox } from "mint-ui";
 */
import "mint-ui/lib/style.css";
import "./assets/styles/reset.css";
import "./assets/styles/border.css";
import "./assets/styles/common.css";


// 极验验证
import axios from "axios";
Vue.prototype.axios = axios;
// 导入极验
require('@/utils/gt.js');
// 绑定到原型
Vue.prototype.$initGeet=initGeetest;

Vue.config.productionTip = false;
/**
 * 这里挂载整个代码库所需要的全局属性和插件。
 * 有些子模块需要的插件请在对应的模板中挂载。
 */

Vue.prototype.global = global_;
Vue.use(VueLazyload);
// Vue.use(VueLazyLoad,{
//    preLoad: 1.3,
//    // error:'./static/error.png',
//    // loading:'./static/loading.png',
//    // attempt: 1
//  });
/**
 * 在需要的地方引入外部js
 * 如果没有协议就是用当前网页域名，本地要做下处理。
 */
Vue.component('remote-script', {
  render: function (createElement) {
    var self = this;
    let src = "";
    // 用当前网页域名，本地要做下处理否则找不到文件。  
    if (!(this.src.startsWith('https://') || this.src.startsWith('http://')) && global_.isLoc) {
      if (router.app.$route.matched && router.app.$route.matched.length > 0) {
        router.app.$route.matched.forEach(item => {
          // 很多客 很多宝
          if (item.path == "/LayoutTemplate/LayoutFound" || item.path == "/LayoutTemplate/LayoutFound2") {
            src = `https://henduoke.quanc.com.cn`;
          }
          // 如是
          if (item.path == "/LayoutTemplate/LayoutFound3" || item.path == "/LayoutTemplate/LayoutFound4") {
            src = `https://yuanquan.gbtse.com`;
          }
          if (global_.isLoc) {
            src = "http://localhost:2000/gong/yuanquan/shqc-web";
          }
        })
      }
    }
    src += this.src;
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: src
      },
      on: {
        load: function (event) {
          self.$emit('load', event);
        },
        error: function (event) {
          self.$emit('error', event);
        },
        readystatechange: function (event) {
          if (this.readyState == 'complete') {
            self.$emit('load', event);
          }
        }
      }
    });
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
});

/**
 * 在需要的地方引入外部css
 * 如果没有协议就是用当前网页域名，本地要做下处理。
 */
Vue.component('remote-link', {
  render: function (createElement) {
    var self = this;
    let src = "";
    // 用当前网页域名，本地要做下处理否则找不到文件。  
    if (!(this.src.startsWith('https://') || this.src.startsWith('http://')) && global_.isLoc) {
      if (router.app.$route.matched && router.app.$route.matched.length > 0) {
        router.app.$route.matched.forEach(item => {
          // 很多客 很多宝
          if (item.path == "/LayoutTemplate/LayoutFound" || item.path == "/LayoutTemplate/LayoutFound2") {
            src = `https://henduoke.quanc.com.cn`;
          }
          // 如是
          if (item.path == "/LayoutTemplate/LayoutFound3" || item.path == "/LayoutTemplate/LayoutFound4") {
            src = `https://yuanquan.gbtse.com`;
          }
        })
      }
    }
    src += this.src;
    return createElement('link', {
      attrs: {
        rel: 'stylesheet',
        href: src
      },
      on: {
        load: function (event) {
          self.$emit('load', event);
        },
        error: function (event) {
          self.$emit('error', event);
        },
        readystatechange: function (event) {
          if (this.readyState == 'complete') {
            self.$emit('load', event);
          }
        }
      }
    });
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
});
let myVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
window.myVue = myVue;
export default myVue;